import type { ArtifactFeedsDataSlice } from './artifact-feeds.type'

export const artifactFeedsInitialState: ArtifactFeedsDataSlice = {
  feeds: [],
  loading: true,
  error: null,
  lastFetchedProjectId: null,
}
